import * as types from './actionTypes';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  loading: true,
  eatery: {},
  cities : [],
  related : [],
  featured : []
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.LOADED:
      return {
        ...state,
        loading: false,
        cities: action.cities,
        eatery: action.eatery,
        related: action.related,
        featured: action.featured
      };
    default:
      return state;
  }
}

//Selectors
export function getValue(state, key) {
  const value = state["eatery"][key];
  switch (key) {
    default:
      return value;
  }
}

export function getAllValues(state, key) {
  return state["eatery"];
}